export default __webpack_public_path__ + "static/media/damage_reduction.adc98233.svg";